import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';

class FormText extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange(e) {
        this.props.onChange(e);
    }

    onBlur(e) {
        if (this.props.onBlur == null) {
            return;
        }

        this.props.onBlur(e)
    }

    render() {
        var value = (this.props.value == null) ? "" : this.props.value;

        // allowHtml is only set for backoffice-authored text, never for user input
        let labelContent = this.props.allowHtml
            ? <span dangerouslySetInnerHTML={{ __html: this.props.text }} />
            : this.props.text;

        // an html question can mark where the question itself ends with <span class="question">, css
        // then renders the mark right behind it instead of at the end of the whole label
        let marksOwnQuestion = this.props.allowHtml && (this.props.text || "").indexOf('class="question"') >= 0;
        let requiredMark = (this.props.required && !marksOwnQuestion) ? <span className="required-mark">*</span> : null;

        return (
            <div className={"tr " + this.props.className}>
                <div className="FieldLabel td">
                    <label htmlFor={this.props.id} className={this.props.required ? "required" : null}>{labelContent}
                        {requiredMark}
                    </label>
                </div>
                <div className="EditingFormValueCell td">
                    <textarea id={this.props.id} maxLength={(this.props.maxLength > 0) ? this.props.maxLength : 2000} className="form-control" rows={(this.props.rows < 1) ? 5 : this.props.rows} onBlur={this.onBlur} onChange={this.onChange} value={value} />
                    <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                </div>
            </div>
        );
    }
}

export default FormText;



// WEBPACK FOOTER //
// ./src/Fields/FormText.js